<template>
  <v-container
    id="app-settings"
    pa-0
    pt-2
  >
    <tabs
      v-model="tab"
      :headers="headers"
    >
      <!-- ****************************
      ********** PREFERENCES **********
      ***************************** -->
      <common
        slot="tab_0"
        class="pl-1"
        @refresh-title="setTitle"
        @launch-init="launchInit"
        @reload-catalogue="reloadCatalogue"
        @app-upgrade="appUpgrade"
        @set-brightness="$emit('set-brightness', arguments)"
        @set-vibration="$emit('set-vibration', arguments)"
      />

      <!-- ****************************
      ********** BANKING PAX **********
      ***************************** -->
      <template v-if="useBanking">
        <pax
          v-if="paymentService === 'pax'"
          slot="tab_1"
          class="pl-1"
        />
        <nepting
          v-else
          slot="tab_1"
          class="pl-1"
        />
      </template>

      <!-- ***********************
      ********* CAMPAIGN *********
      ************************ -->
      <campaign
        v-if="useCampaign"
        :slot="useBanking ? 'tab_2' : 'tab_1'"
        class="pl-1"
      />

      <!-- *************************
      ********** A PROPOS **********
      ************************** -->
      <scrollable
        :slot="(useBanking && useCampaign) ? 'tab_3' : (useBanking || useCampaign ? 'tab_2' : 'tab_1')"
        full
        class="pl-1"
      >
        <v-card class="pa-3">
          <div class="bloc headline">
            {{ userName }}
          </div>
          <v-divider
            v-show="userName !== null && userName !== ''"
            class="my-2"
          />
          <div class="bloc headline">
            {{ merchantName }}
          </div>
          <v-divider class="my-2" />
          <div v-show="rank">
            <div class="bloc mt-2">
              <span class="body-2">{{ $t('field.index.pdv') }}</span> : {{ pdv }}
            </div>
            <div class="bloc">
              <span class="body-2">{{ $t('field.index.rank') }}</span> : {{ rank }}
            </div>
            <div class="bloc mt-2">
              <span class="body-2">{{ $t('field.index.version') }} {{ appName }}</span> : {{ version }}
            </div>
          </div>
        </v-card>
      </scrollable>
    </tabs>

    <bottom-action
      btn-valid
      btn-del-disabled
      btn-cancel-disabled
      :use-listener="false"
      @valid="backToHome"
    />
  </v-container>
</template>

<script>
import { MetierLocalStorage } from 'modulelocalstorage'

import { name, version } from '../../package.json'
import { Initialisation } from '@/modules/Initialisation'

import Tabs from '@/components/Tabs'
import Common from '@/components/settings/Common'
import Nepting from '@/components/settings/banking/Nepting'
import Pax from '@/components/settings/banking/Pax'
import Campaign from '@/components/settings/Campaign'

import { $alert, $amount } from '@/modules/Utils'
import { IntentAction } from '@/modules/Enums'

export default {
  name: 'SettingsView',

  components: {
    Campaign,
    Pax,
    Tabs,
    Common,
    Nepting
  },

  props: {
    toTab: { type: Number, default: 0 },
    checkConnected: { type: Boolean, default: true }
  },

  data () {
    return {
      IS_PAX,
      tab: this.toTab,
      appName: name,
      version,
      //
      merchantName: this.$store.state.merchantName,
      userName: this.$store.state.userName,
      pdv: MetierLocalStorage.getIdPointDeVente(),
      licence: MetierLocalStorage.getLicence(),
      rank: MetierLocalStorage.getRang()
    }
  },

  computed: {
    paymentService () { return this.$store.getters.paymentService },
    useCampaign () { return this.$store.getters.campaigns.length > 0 },
    useBanking () { return this.$store.getters.useBanking },
    headers () {
      const res = ['settings']
      if (this.useBanking) res.push(this.$i18n.t('button.settings.banking'))
      if (this.useCampaign) res.push(this.$i18n.t('button.settings.campaigns'))
      res.push(this.$i18n.t('button.settings.about'))
      return res
    }
  },

  beforeMount () {
    if (this.checkConnected && this.$store.state.teleparameters === null) {
      this.$router.replace('/')
    } else {
      this.setTitle()
    }
  },

  methods: {
    $amount,
    setTitle () {
      this.$emit('title', this.$i18n.t('title.settings'))
    },
    reloadCatalogue () {
      this.$store.commit('listproducts', [])

      Initialisation.initProducts(
        MetierLocalStorage.getCatalogueId(),
        (e) => {
          this.$store.commit('listproducts', MetierLocalStorage.getProducts())
          $alert(e)
        },
        (success) => {
          // Alerte succès + retour home
          $alert(this.$i18n.t('success.catalogue_updated'), 'success')
          this.$router.replace('home')
        }
      )
    },
    launchInit () {
      this.$store.commit('listproducts', [])
      this.$store.commit('actionItems', null)

      Initialisation.prepareInitialisation(
        {
          'IDPointDeVente': this.pdv,
          'Licence': this.licence,
          'Rang': this.rank,
          'binDroits': MetierLocalStorage.getUserRights()
        },
        (e) => {
          $alert(e)
          // MetierLocalStorage.clear()
          // this.$store.dispatch('clear')
          // this.$router.replace('/')
        },
        true
      )
    },
    backToHome () {
      if (this.$store.getters.externalAction === IntentAction.SETTINGS) {
        CissAndroid.sendSuccess()
      } else if (this.checkConnected) {
        this.$router.replace('/home')
      } else {
        this.$router.replace('/')
      }
    },
    appUpgrade () {
      this.$store.commit('loader', this.$i18n.t('loader.app_upgrade'))

      AutoInstall.upgrade(
        version,
        _ => {
          // Close app for upgrade
          navigator.app.exitApp()
        },
        (error) => {
          this.$store.commit('loader', false)
          $alert(error)
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.amount-seuil-min{
  width: 100%;
  display: inline-flex;
  justify-content: flex-end;
  font-size: 20px;
}

.active-class-window{
  background-color: red;
}

#custom-tab-items {
  background-color: transparent !important;
}

.plage-desactivation-item{
  display: inline-flex;
  flex-direction: row;
  background-color: grey;
  height: 40px;
  align-items: center;
  padding: 5px 15px;

  .title{
    flex: 1;
  }

  &.selected{
    background-color: cadetblue;
  }
}
</style>
